import { render, staticRenderFns } from "./eha.vue?vue&type=template&id=89b90122&"
import script from "./eha.vue?vue&type=script&lang=js&"
export * from "./eha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports